import { render, staticRenderFns } from "./Milestone.vue?vue&type=template&id=0a2ffaf2&scoped=true"
import script from "./Milestone.vue?vue&type=script&lang=js"
export * from "./Milestone.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a2ffaf2",
  null
  
)

export default component.exports